/* Organique Kuwait – round 5 additions (kept separate from organique.js) */
(function () {
  'use strict';
  var d = document;

  /* Menu drawer: open the section the shopper is in (e.g. Body Care on the Shower Gel page) */
  function openActiveSection() {
    each(d.querySelectorAll('.menu-drawer accordion-custom'), function (acc) {
      var det = acc.querySelector('details');
      var sum = det && det.querySelector('summary');
      if (sum && sum.classList.contains('menu-drawer__menu-item--active') && !det.open) det.open = true;
    });
  }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('accordion-custom').then(openActiveSection);
  }
  d.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.id === 'Details-menu-drawer-container' && t.open) openActiveSection();
  }, true);

  /* Cart drawer: don't bring it back open on the next page (desktop "squeeze" restore) */
  function noPersist() {
    var cart = d.querySelector('theme-drawer#cart-drawer');
    if (cart && !cart.hasAttribute('no-persist')) cart.setAttribute('no-persist', '');
  }
  noPersist();
  d.addEventListener('DOMContentLoaded', noPersist);
})();

/* ---------- Collections: live count on "Show results" and fresh option counts (G10) ---------- */
(function () {
  'use strict';
  var d = document;
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function esc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }
  function params(form) {
    var p = new URLSearchParams();
    each(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.type === 'number' && el.value === '') return;
      p.append(el.name, el.value);
    });
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 || k === 'page' || k === 'section_id' || p.has(k)) return;
      p.append(k, v);
    });
    return p;
  }
  each(d.querySelectorAll('form[data-org-filters]'), function (form) {
    var dl = form.closest('dialog');
    var sid = dl && dl.id.indexOf('OrgFilters-') === 0 ? dl.id.slice(11) : '';
    var btn = form.querySelector('button[type="submit"]');
    if (!sid || !btn) return;
    var base = btn.textContent.trim();
    var timer, seq = 0;
    function refresh() {
      var my = ++seq;
      var p = params(form);
      p.set('section_id', sid);
      btn.setAttribute('aria-busy', 'true');
      fetch(form.getAttribute('action') + '?' + p.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (my !== seq) return;
          var tmp = d.createElement('div');
          tmp.innerHTML = html;
          var c = tmp.querySelector('.org-toolbar__count');
          var n = c ? (c.textContent.match(/\d+/) || [])[0] : null;
          btn.textContent = n != null ? base + ' (' + n + ')' : base;
          var fresh = tmp.querySelector('form[data-org-filters]');
          if (!fresh) return;
          each(form.querySelectorAll('.org-check input[type="checkbox"]'), function (inp) {
            var twin = fresh.querySelector('input[type="checkbox"][name="' + esc(inp.name) + '"][value="' + esc(inp.value) + '"]');
            var lab = inp.closest('.org-check');
            if (!twin || !lab) return;
            var cnt = lab.querySelector('.org-check__count');
            var tcnt = twin.closest('.org-check') && twin.closest('.org-check').querySelector('.org-check__count');
            if (cnt && tcnt) cnt.textContent = tcnt.textContent;
            var off = twin.disabled && !inp.checked;
            lab.classList.toggle('is-disabled', off);
            inp.disabled = off;
          });
        })
        .catch(function () { btn.textContent = base; })
        .then(function () { if (my === seq) btn.removeAttribute('aria-busy'); });
    }
    form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(refresh, 150); });
    form.addEventListener('input', function (e) {
      if (e.target && e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(refresh, 600); }
    });
  });
})();

/* ---------- Collections: "Show more products" instead of page numbers (G18) ---------- */
(function () {
  'use strict';
  var d = document;
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  each(d.querySelectorAll('.org-pagination'), function (nav) {
    var host = nav.parentElement;
    var grid = host && host.querySelector('.org-coll__grid');
    var next = nav.querySelector('a[rel="next"]');
    var sec = nav.closest('.shopify-section');
    if (!grid || !next || !sec || nav.querySelector('a[rel="prev"]')) return;
    var sid = sec.id.replace('shopify-section-', '');
    var wrap = d.createElement('div');
    wrap.className = 'org-loadmore';
    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'org-btn org-btn--ghost org-loadmore__btn';
    btn.textContent = (window.OrgT && window.OrgT.loadMore) || 'Show more products';
    wrap.appendChild(btn);
    host.insertBefore(wrap, nav);
    nav.hidden = true;
    var url = next.getAttribute('href');
    btn.addEventListener('click', function () {
      if (!url) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      var u = new URL(url, window.location.href);
      u.searchParams.set('section_id', sid);
      fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var tmp = d.createElement('div');
          tmp.innerHTML = html;
          var g = tmp.querySelector('.org-coll__grid');
          var firstNew = null;
          if (g) each(Array.prototype.slice.call(g.children), function (item) {
            grid.appendChild(item);
            if (!firstNew) firstNew = item;
          });
          var n2 = tmp.querySelector('.org-pagination a[rel="next"]');
          url = n2 ? n2.getAttribute('href') : null;
          if (!url) wrap.remove();
          var link = firstNew && firstNew.querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = url; })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
    });
  });
})();

/* ---------- Collections: desktop side panel applies at once, long lists, sort select (G09/G16) ---------- */
(function () {
  'use strict';
  var d = document;
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-org-more]') : null;
    if (!b) return;
    var fs = b.closest('.org-filter');
    if (!fs) return;
    fs.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    var first = fs.querySelector('.org-check--more input');
    if (first) first.focus();
  });
  each(d.querySelectorAll('form[data-org-inline]'), function (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'checkbox') return;
      form.classList.add('is-loading');
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });
  each(d.querySelectorAll('select[data-org-sortsel]'), function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
})();
